<form [formGroup]="filterForm">
  <div
    class="flex-wrap align-items-center"
    style="
      grid-gap: 15px;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    "
  >
    <div class="style2023">
      <div class="input-group">
        <div class="input-group-item">
          <input
            pInputText
            name="searchText"
            type="text"
            style="width: 100%"
            placeholder="Search order, job, reg"
            formControlName="searchText"
          />
        </div>
      </div>
    </div>
    <div>
      <p-multiSelect
        class="filter-multiselect narrow-multiselect"
        defaultLabel="All Customers"
        [options]="customers"
        formControlName="customerIds"
      ></p-multiSelect>
    </div>
    <div>
      <p-multiSelect
        class="filter-multiselect narrow-multiselect"
        defaultLabel="All Departments"
        [options]="departmentOptions"
        formControlName="departmentIds"
      ></p-multiSelect>
    </div>
    <div>
      <p-multiSelect
        class="filter-multiselect narrow-multiselect"
        defaultLabel="All Teams"
        [options]="teamOptions"
        formControlName="teamIds"
      ></p-multiSelect>
    </div>
    <div>
      <p-multiSelect
        class="filter-multiselect narrow-multiselect"
        defaultLabel="All Issue Types"
        [options]="checkTypes"
        formControlName="checkTypes"
      ></p-multiSelect>
    </div>
    <div>
      <p-multiSelect
        class="filter-multiselect narrow-multiselect"
        defaultLabel="All Progress"
        [options]="issueProgress"
        formControlName="issueProgress"
      ></p-multiSelect>
    </div>
    <div>
      <p-multiSelect
        class="filter-multiselect narrow-multiselect"
        defaultLabel="All Customer Priorities"
        [options]="priorities"
        formControlName="priorities"
      ></p-multiSelect>
    </div>
    <div class="style2023">
      <div class="input-group">
        <div class="input-group-item">
          <p-dropdown
            class="input-group-filter"
            name="raisedWithinDays"
            [options]="raisedWithinDayOptions"
            formControlName="raisedWithinDays"
          ></p-dropdown>
        </div>
      </div>
    </div>

    <div class="style2023">
      <div class="input-group">
        <div class="input-group-item">
          <p-dropdown
            class="input-group-filter"
            name="supplierAssigned"
            [options]="supplierAssignedOptions"
            formControlName="supplierAssigned"
          ></p-dropdown>
        </div>
      </div>
    </div>

    <div>
      <p-multiSelect
        class="filter-multiselect narrow-multiselect"
        defaultLabel="All Booking Statuses"
        [options]="bookingStatuses"
        formControlName="bookingStatuses"
      ></p-multiSelect>
    </div>
    <div class="flex gap-2">
      <div class="flex-shrink-1">
        <button class="button-style" (click)="searchClicked.emit(filterForm.getRawValue())">
          <i class="fa fa-search"></i>&nbsp;Search
        </button>
      </div>

      <div class="flex-shrink-1">
        <button
          class="button-style ui-button-tertiary transparent"
          title="Reset filters"
          (click)="resetClicked()"
        >
          <i class="fa fa-undo"></i>
        </button>
      </div>
    </div>
  </div>
</form>
